import { TotemIconId } from '@meilleurtaux/mtp-uikit-core';

enum STATUS {
  INFO = 'info',
  WARNING = 'warning',
  SUCCESS = 'success',
  ERROR = 'error',
}

const STATUS_ICON: Record<STATUS, TotemIconId> = {
  [STATUS.INFO]: 'info-circle',
  [STATUS.WARNING]: 'warning',
  [STATUS.SUCCESS]: 'check-circle',
  [STATUS.ERROR]: 'cross-circle',
};

export { STATUS, STATUS_ICON };
